export const parseStatValue = (value) => {
    if (value == null || value === '—' || value === '') {
        return 0;
    }

    const str = String(value).trim().replace(/%$/, '');
    const suffixMatch = str.match(/^([\d.]+)\s*([KMB])$/i);

    if (suffixMatch) {
        const num = parseFloat(suffixMatch[1]);
        const multipliers = { K: 1_000, M: 1_000_000, B: 1_000_000_000 };
        return num * (multipliers[suffixMatch[2].toUpperCase()] || 1);
    }

    const parsed = parseFloat(str.replace(/,/g, ''));
    return Number.isFinite(parsed) ? parsed : 0;
};

const CONTACT_PERCENT_STATS = {
    PATIENTS_EMAIL_PERCENT: 'PATIENTS_WITH_EMAIL',
    PATIENTS_CELL_PHONE_PERCENT: 'PATIENTS_WITH_CELL_PHONE',
    PATIENTS_HOME_PHONE_PERCENT: 'PATIENTS_WITH_HOME_PHONE',
};

export const formatPercentage = (part, total, { decimals = 1 } = {}) => {
    const numerator = parseStatValue(part);
    const denominator = parseStatValue(total);

    if (!denominator) {
        return '—';
    }

    const percent = (numerator / denominator) * 100;
    return `${percent.toFixed(decimals)}%`;
};

export const resolveStatValue = (statsMap = {}, key) => {
    if (statsMap[key] != null && statsMap[key] !== '') {
        return statsMap[key];
    }

    const sourceKey = CONTACT_PERCENT_STATS[key];
    if (!sourceKey) {
        return '—';
    }

    return formatPercentage(statsMap[sourceKey], statsMap.TOTAL_PATIENTS);
};

export const hasChartData = (series = []) =>
    series.some((item) => parseStatValue(item.value) > 0);
